import { render, staticRenderFns } from "./submissionDialog.vue?vue&type=template&id=7a27434e&"
import script from "./submissionDialog.vue?vue&type=script&lang=js&"
export * from "./submissionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports